export const SET_EDIT_STAY_GUEST = 'SET_EDIT_STAY_GUEST'

export const updateGuest = guestRoomGroup => ({
	type: SET_EDIT_STAY_GUEST,
	payload: guestRoomGroup
})

export default function setEditStayGuest(roomGroup, adults, children, dogs, cats) {
	let keyedRoomGroup = {}
	const roomGroupData = {
		adults: adults,
		children: children,
		dogs: dogs,
		cats: cats
	}

	keyedRoomGroup[roomGroup] = roomGroupData

	return dispatch => {
		dispatch(updateGuest(keyedRoomGroup))
	}
}



// WEBPACK FOOTER //
// ./src/actions/setEditStayGuest.js